module.exports = __webpack_public_path__ + "static/img/pin-multi-scheduled.6693cfa.svg";